<template lang="pug">
  div(v-loading="processing")
    el-row#quiz-section
      el-col(:span="24" style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center;")
        // Logo
        div
          img(class="mini-logo" src="@/assets/icons/hvu_practice_icon.svg")
        
        // Title and Description
        div(style="width: 90%; margin: 2%;")
          h2#title-info {{ data.title }}
          span {{ data.description }}
    
    el-row(style="margin-top: 1%;")
      el-col#question-view
        // Question view
        question-placeholder(
          v-if="question != null"
          :questionInfo="question"
          :index="questionIndex+1"
          :totalCount="questionCount"
          @questionSubmitted="markQuestion"
          style="margin-left: 2%;")
       
      // Side panel Question No. Navigation
      el-col#question-tab-col(style="width: 12.5%; padding-bottom: 4%;")
        div(style="min-height: 100px;")
          div#question-tabs(
            v-for="item, index in data.questions" v-model="data.questions"
            :class="{'answered-question-tab':  item.isAnswered, 'current-question-tab': questionIndex === index,'normal-question-tab': !item.isAnswered && questionIndex != index}"
            @click="showQuestion(index)")
            span(
              :ref="index") Q{{ index + 1 }}
                              
</template>

<script>
import QuestionPlaceholder from "@/components/demo/questions/QuestionPlaceholder";

export default {
  name: "Quiz",

  components: {
    QuestionPlaceholder
  },

  props: {
    type: {
      type: String,
      default: "answerinput"
    }
  },

  data() {
    return {
      processing: true,
      data: {},
      question: null,
      questionIndex: 0,
      questionCount: 0
    };
  },

  watch: {
    type() {
      this.data = require(`@/defines/demo/${this.type}.json`);
      this.questionCount = this.data.questions.length;
      this.showQuestion(0);
    }
  },

  mounted() {
    this.data = require(`@/defines/demo/${this.type}.json`);
    this.questionCount = this.data.questions.length;
    this.showQuestion(0);
    this.processing = false;
  },

  methods: {
    showQuestion(index) {
      this.question = this.data.questions[index];
      this.questionIndex = index;
    },

    markQuestion(obj) {
      for (let i = 0; i < this.data.questions.length; i += 1) {
        if (
          this.data.questions[i].id === obj.id &&
          !this.data.questions[i].isAnswered
        ) {
          this.data.questions[i].isAnswered = true;
          break;
        }
      }
    }
  }
};
</script>

<style>
#quiz-section {
  border: 1px solid var(--light-blue-two);
  border-radius: 7px;
  margin: 0% 1%;
  padding: 1em;
}

#title-info {
  color: var(--purple-blue);
  font-size: 2em;
  margin-top: 1%;
  margin-bottom: 1%;
}

#question-view {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 84%;
  margin: 0% 1%;
  padding: 1%;
  border: 1px solid var(--light-blue-two);
  border-radius: 7px;
}

#question-tab-col {
  text-align: center;
  vertical-align: middle;
  margin-left: 0.25%;
}

#question-tabs {
  text-align: center;
  padding: 10%;
  margin-bottom: 2%;
  cursor: pointer;
  border: 1px solid var(--light-blue-one);
  border-radius: 7px;
}

#question-tabs div {
  margin: 5%;
}

#question-tabs:hover {
  background-color: #eeeeee;
  border-radius: 5px;
}

.current-question-tab {
  font-weight: bold;
  border-radius: 5px;
  color: #fff !important;
  background-color: var(--button-blue) !important;
}

.normal-question-tab {
  color: var(--text-gray);
  font-weight: normal;
}

.answered-question-tab {
  color: var(--hvu-green);
  font-weight: bold;
}
</style>
